import { useMemo } from 'react';
import { useLingui } from '@lingui/react';
import { useGet } from 'lib/api';
import { apiUsers } from 'api/users';
import type { FeatureFlags } from 'modules/accessControl/types';
import { getIframeDetailBreadcrumb, type IframeDetailBreadcrumb } from '../utils';

export function useIframeDetailBreadcrumb(pathname: string): IframeDetailBreadcrumb | null {
  const { _ } = useLingui();
  const { data: featureFlags } = useGet<FeatureFlags>(
    apiUsers.get.featureFlags,
    'feature-flags',
    undefined,
    undefined,
    false
  );

  return useMemo(
    () => getIframeDetailBreadcrumb(pathname, featureFlags, _),
    [pathname, featureFlags, _]
  );
}
